import './announcement.scss'
import 'swiper/swiper.min.css'
import Swiper from 'swiper'

const FADE = 300

function holdTime(carousel) {
  const seconds = Number(carousel.getAttribute('data-delay'))
  if (!Number.isFinite(seconds)) return 5000
  return Math.min(60, Math.max(1, seconds)) * 1000
}

function init() {
  const carousel = document.querySelector('[data-announcement-carousel]')
  if (!carousel) return

  const HOLD = holdTime(carousel)

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)')

  const syncSlideAccess = () => {
    carousel.querySelectorAll('.swiper-slide').forEach((slide) => {
      const active = slide.classList.contains('swiper-slide-active')
      slide.setAttribute('aria-hidden', active ? 'false' : 'true')
      slide.querySelectorAll('a').forEach((link) => {
        if (active) {
          link.removeAttribute('tabindex')
          return
        }
        link.setAttribute('tabindex', '-1')
      })
    })
  }

  const swiper = new Swiper(carousel, {
    loop: true,
    speed: 0,
    allowTouchMove: false,
    on: {
      init: syncSlideAccess,
      slideChange: syncSlideAccess,
    },
  })

  let holdTimer
  let fadeTimer
  let paused = false

  const clearTimers = () => {
    window.clearTimeout(holdTimer)
    window.clearTimeout(fadeTimer)
  }

  const schedule = () => {
    clearTimers()
    carousel.classList.remove('is-fading')
    if (paused) return

    holdTimer = window.setTimeout(() => {
      if (reduced.matches) {
        swiper.slideNext(0)
        schedule()
        return
      }

      carousel.classList.add('is-fading')
      fadeTimer = window.setTimeout(() => {
        swiper.slideNext(0)
        carousel.classList.remove('is-fading')
        schedule()
      }, FADE)
    }, HOLD)
  }

  carousel.addEventListener('mouseenter', () => {
    paused = true
    schedule()
  })

  carousel.addEventListener('mouseleave', () => {
    paused = false
    schedule()
  })

  carousel.addEventListener('focusin', () => {
    paused = true
    schedule()
  })

  carousel.addEventListener('focusout', () => {
    paused = false
    schedule()
  })

  reduced.addEventListener('change', schedule)
  schedule()
}

export default init
